<template>
    <InfoModal v-model:open="open" title="Nadia has been analyzing your conversations" :sections="sections" />
</template>

<script setup lang="ts">
import InfoModal, { type InfoModalSection } from "./InfoModal.vue";

const open = defineModel<boolean>("open", { default: false });

const sections: InfoModalSection[] = [
    {
        icon: "bi-chat-quote",
        title: "When you chat about goals, they show up here",
        description: "Goals refined through conversation surface here for you to track and act on",
    },
    {
        icon: "bi-arrow-repeat",
        title: "Review suggestions and help Nadia improve",
        description: "Tracking which goals resonate improves future suggestions over time",
    },
];
</script>
